import React from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';

const PayAmount = (props) => {
    const { disabled, index, expense, isViewOnly } = props;
    const { control, errors, getValues, trigger } = useFormContext();

    return (
        <Grid2 item size={4}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].payAmount`}
                defaultValue={expense.payAmount}
                rules={{
                    validate: (v) => {
                        if (v === '' || v == null) return 'Amount is required';
                        const other = getValues(`expenseEntries[${index}].billAmount`);
                        const a = Number(v);
                        const b = Number(other || 0);
                        if (Number.isNaN(a)) return 'Enter a valid number';
                        if (a > 99999.99) return "Amount can't exceed 99,999.99";
                        if (a === 0 && b === 0)
                            return 'Payment Amount and Bill Amount cannot both be 0';
                        return true;
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required
                        placeholder="0.00"
                        id="pay-amount"
                        onChange={(e) => {
                            onChange(valueAsExpense(e.target.value));
                            props.updatePaymentTotalAmount();
                            trigger([
                                `expenseEntries[${index}].billAmount`,
                                `expenseEntries[${index}].payAmount`,
                            ]);
                        }}
                        value={value}
                        label="Pay Amount"
                        endAdornment={
                            <AmountCurrencyInputAdornment
                                disabled={disabled || isViewOnly}
                                index={index}
                                currencyType={expense.currency}
                                name={`expenseEntries[${index}].paymentCurrency`}
                            />
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.payAmount)}
                        disabled={isViewOnly}
                        helperText={errors.expenseEntries?.[index]?.payAmount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default PayAmount;
